import React from 'react'

import { ButtonGroup, ButtonGroupProps } from '../../../components/forms/button-group/button-group.js'
import { GridColumn } from '../../../components/grid/grid-column.js'
import { Grid } from '../../../components/grid/grid.js'

export interface LanguageProps {
    title: string
    subtitle: string
    languageSelector: ButtonGroupProps
}

export const Languages = (props: LanguageProps): JSX.Element => {
    return (
        <div className="text">
            <Grid className="text__margin-double login__options" justify={['center-xs']}>
                <GridColumn width={['md-10', 'lg-5']}>
                    <div className="text">
                        <h3>{props.title}</h3>
                        <p>{props.subtitle}</p>
                        <ButtonGroup {...props.languageSelector} />
                    </div>
                </GridColumn>
            </Grid>
        </div>
    )
}
